<template>
  <div class="copyBetgame">
    <div class="adbanner">
      <img v-if="this.$store.state.language === 'de'" v-on:click="copyBetgame" src="../assets/images/teamtip/teamtip_neue_saison-de-600x200.png" alt="" data-testid="betgame-copy">
      <img v-else-if="this.$store.state.language === 'fr'" v-on:click="copyBetgame" src="../assets/images/teamtip/teamtip_changer_saison-fr-600x200.png" alt="" data-testid="betgame-copy">
      <img v-else v-on:click="copyBetgame" src="../assets/images/teamtip/teamtip_new_season-en-600x200.png" alt="" data-testid="betgame-copy">
    </div>
  </div>
</template>

<script>
export default {
  name: 'CopyBetgame',
  components: {},
  data () {
    return {}
  },
  beforeCreate () {
  },
  created () {
  },
  mounted () {
  },
  computed: {},
  methods: {
    copyBetgame() {
      this.$gtag.event('TipprundeKopieren', {
        'event_category': 'copyBetgame',
        'event_label': 'teamtip.dashboard',
        'dimension1': this.$store.state.betgame && this.$store.state.betgame.name ? this.$store.state.betgame.name : 'betgame not set',
        'dimension2': this.$store.state.user && this.$store.state.user.source ? this.$store.state.user.source : 'user source not set',
        'dimension3': this.$store.state.betgame && this.$store.state.betgame.id ? this.$store.state.betgame.id : 'betgame id not set',
        'dimension5': this.$store.state.betgame && this.$store.state.betgame.type ? this.$store.state.betgame.type : 'betgame type not set'
      })
      this.$router.push({ name: 'betgamecopy', params: { betgame: this.$store.state.betgame, action: 'copy' } })
    },
  }
}
</script>

<style lang="scss">
.copyBetgame {
  background: var(--color-surface);
  box-shadow: 0 0 1px 0 rgba(var(--color-text-rgb), .08), 0px 4px 16px rgba(var(--color-text-rgb), 0.08);
  border-radius: 8px;
  width: 100%;
  margin-bottom: 24px;
}
</style>
